import { create } from 'zustand';
import {  MenuData, VisualContent } from '../interfaces/domain/menu';


interface Feature {
  name: string;
  priority: number;
  items: string[];
}

interface ItemsState {
  menuData: MenuData;
  featuresData: Feature[];
  carouselContent: VisualContent[];
  hasFilter: boolean;
  menuLastUpdatedIso: string | null;
  menuRestaurantId: string | null;
  menuMode: 'LOCAL' | 'DELIVERY' | null;
  menuUpdatedWarning: boolean;

  // Acciones
  setMenu: (menuData: MenuData) => void;
  setHasFilter: (value: boolean) => void;
  setFeatures: (features: Feature[]) => void;
  setCarouselContent: (data: VisualContent[]) => void;
  setMenuMeta: (restaurantId: string, mode: 'LOCAL' | 'DELIVERY', lastUpdatedIso: string) => void;
  setMenuUpdatedWarning: (value: boolean) => void;
}

export const useItemsStore = create<ItemsState>((set) => ({
  menuData: {
    categories: [],
  },
  hasFilter: false,
  featuresData: [],
  carouselContent: [],
  menuLastUpdatedIso: null,
  menuRestaurantId: null,
  menuMode: null,
  menuUpdatedWarning: false,

  setMenu: (menuData) =>
    set({
      menuData
    }),
  setHasFilter: (value) => set({ hasFilter: value }),
  setFeatures: (features) => set({ featuresData: features }),
  setCarouselContent: (carouselContent) => set({ carouselContent }),
  setMenuMeta: (restaurantId, mode, lastUpdatedIso) =>
    set({ menuRestaurantId: restaurantId, menuMode: mode, menuLastUpdatedIso: lastUpdatedIso }),
  setMenuUpdatedWarning: (value) => set({ menuUpdatedWarning: value }),
}));
